<ng-container *ngIf="!isMobile">
  <div class="container-fluid ps-md-0">
    <div class="row g-0 vh-100">
      <div
        class="d-none d-md-flex col-md-4 col-lg-6 bg-image"
        [ngStyle]="{
          'background-image':
            'url(../../../../assets/image/merchants/' +
            merchant +
            '/bg-login.svg)'
        }"
      >
        <div class="text mt-5">
          <span [innerHTML]="getWelcomeText()"></span>
        </div>
        <div class="logo">
          <div class="text-white" *ngIf="tenant !== tenantService.XP_NAME">
            <span>Fornecido por: </span>
          </div>
          <br />
          <img src="../../../../assets/image/oz-white-logo.svg" alt="logo" />
        </div>
      </div>

      <div class="col-md-8 col-lg-6 content-center">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isMobile && !isPasswordReset">
  <ng-container *ngIf="!isLogin">
    <div class="container-fluid ps-md-0">
      <div class="row g-0">
        <div
          class="col-md-8 col-lg-6 bg-mobile"
          [ngStyle]="{
            'background-image':
              'url(../../../../assets/image/merchants/' +
              merchant +
              '/bg-login.svg)'
          }"
        >
          <img
            class="logo-oz"
            src="../../../../assets/image/merchants/{{
              merchant
            }}/oz-white-logo-no-color.svg"
            alt="logo"
          />

          <div class="title-mobile">
            <span [innerHTML]="getWelcomeText()"></span>
          </div>
        </div>

        <div class="form-mb">
          <div class="text-login mt-3 text-center">
            <div class="text-center pd-bottom-24">
              <img
                src="assets/image/merchants/{{
                  merchant
                }}/logo-login-blue-mobile.svg"
              />
            </div>
            <h4 class="pd-bottom-24">Boas vindas!</h4>
            <p class="pd-bottom-8">
              Entre na sua conta ou crie uma gratuitamente para começar a enviar
              e receber dinheiro para outros paises.
            </p>

            <button
              class="btn btn-block mt-2 btn-dark-blue border-radius-8"
              type="button"
              routerLink="{{ '/' + tenant + '/person-type' }}"
            >
              Criar conta
            </button>

            <button
              (click)="setIsLogin(true)"
              class="btn btn-block mb-3 btn-outline-dark"
              type="button"
            >
              Entrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isLogin">
    <app-login-main
      (setLoginValue)="setIsLogin($event)"
      (setPassValue)="setIsPass($event)"
    ></app-login-main>
  </ng-container>
</ng-container>

<ng-container *ngIf="isMobile && isPasswordReset">
  <router-outlet></router-outlet>
</ng-container>
